import { useAppSelector } from 'hooks';
import React, { useMemo } from 'react';
import { HIGH_ALIGNMENT_SCORE, MINIMUM_SECONDS_LENGTH, NORMAL_ALIGNMENT_SCORE } from './constants';
import { getLocaleDate } from 'utils';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { TIME_SCALE, MV_PER_ROW } from 'utils/constants';

export const ECGDetailsTable = () => {
  const { dbECGData, downloadECGData } = useAppSelector((state) => state.study);
  const alignmentQuality = useMemo(() => {
    const score = downloadECGData?.score;
    if (!downloadECGData) {
      return null;
    }
    switch (true) {
      case score > HIGH_ALIGNMENT_SCORE:
        return 'Good';
      case score > NORMAL_ALIGNMENT_SCORE:
        return 'Fair';
      case score <= NORMAL_ALIGNMENT_SCORE:
        return 'Bad';
      default:
        return 'Failed';
    }
  }, [downloadECGData]);

  const ECGLengthInfo = useMemo(() => {
    if (!dbECGData) {
      return null;
    }
    if (dbECGData?.samples.length < MINIMUM_SECONDS_LENGTH * dbECGData?.sampleRate) {
      console.log(dbECGData.samples.length);
      alert('This recording is too short');
    }

    return `${(dbECGData.samples.length / dbECGData?.sampleRate).toFixed(0)} `;
  }, [dbECGData]);

  return (
    <>
      <TableContainer sx={{ padding: '20px 0' }}>
        <Table
          sx={{
            borderCollapse: 'collapse',
            backgroundColor: '#D6EEEE',
            '& td, & th': {
              border: '1px solid black',
              padding: '5px',
              textAlign: 'center',
            },
          }}
        >
          <TableHead sx={{ '& th': { textAlign: 'center', fontWeight: 'bold' } }}>
            <TableRow>
              <TableCell>Device</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Lead</TableCell>
              <TableCell>Assessment</TableCell>
              <TableCell>Heart Rate</TableCell>
              <TableCell>Date Recorded</TableCell>
              <TableCell>Seconds</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Everbeat</TableCell>
              <TableCell>{dbECGData.patientName}</TableCell>
              <TableCell>{dbECGData?.ecgLead || 'N/A'}</TableCell>
              <TableCell>{dbECGData?.assessment || 'N/A'}</TableCell>
              <TableCell>{dbECGData?.heartRate || 'N/A'}</TableCell>
              <TableCell>{getLocaleDate(dbECGData.submittedTimestamp, 'MM-DD: h:mm:ss a')}</TableCell>
              <TableCell>{ECGLengthInfo}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Holter File</TableCell>
              <TableCell>{downloadECGData ? 'N/A' : ''}</TableCell>
              <TableCell>{downloadECGData?.ecgLead || 'N/A'}</TableCell>
              <TableCell>{downloadECGData?.analysis || 'N/A'}</TableCell>
              <TableCell>N/A</TableCell>
              <TableCell>
                {downloadECGData?.submittedTimestamp
                  ? getLocaleDate(downloadECGData.submittedTimestamp, 'MM-DD-YY : h:mm:ss a')
                  : 'N/A'}
              </TableCell>
              <TableCell>{downloadECGData ? (downloadECGData.samples.length / 512).toFixed(0) : 'N/A'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Alignment Result</TableCell>
              <TableCell sx={{ textAlign: 'center' }} colSpan={5}>
                {alignmentQuality || 'N/A'}
              </TableCell>
              <TableCell>Offset: {downloadECGData?.offset?.toFixed(1) || 'N/A'}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Typography sx={{ fontWeight: 'bold' }}>ECG Scale Details:</Typography>
      <ul>
        <li>Voltage Scale: {MV_PER_ROW} mV/division </li>
        <li>Time Scale: {TIME_SCALE} </li>
      </ul>
    </>
  );
};
